import React from 'react';
import { useHistory } from 'react-router-dom';

export default function Success() {
  const history = useHistory();

  return (
    <div className="successContainer">
      <h1>Payment Successful!</h1>
      <p className="successParagraph">
        Thank you for your purchase. Your order has been processed successfully.
      </p>
      <p className="successParagraph">
        You will receive a confirmation email shortly.
      </p>
      <button 
        onClick={() => history.push('/')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          fontSize: '16px',
          cursor: 'pointer',
          backgroundColor: '#434343',
          color: 'white',
          border: 'none',
          borderRadius: '4px'
        }}
      >
        Return to Home
      </button>
    </div>
  );
}
